import { render, staticRenderFns } from "./GlobalLabelWrapper.vue?vue&type=template&id=04454c14"
import script from "./GlobalLabelWrapper.vue?vue&type=script&lang=ts"
export * from "./GlobalLabelWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports